import React from 'react';

import type { ExtensionHandler } from '@atlaskit/editor-common/extensions/extension-handler';

import { EXTENSION_KEY } from '@confluence/fabric-extension-lib/entry-points/extensionConstants.ts';
import { TemplateVariableComponent } from '@confluence/template-variable/entry-points/TemplateVariableComponent.ts';
import { TemplateVariableInput } from '@confluence/template-variable/entry-points/TemplateVariableInput.ts';

export const getTemplateExtensionHandler: ExtensionHandler<any> = (extension) => {
	if (!extension) {
		return null;
	}

	const { extensionKey, parameters } = extension;
	if (extensionKey === EXTENSION_KEY.TEMPLATE) {
		return <TemplateVariableComponent parameters={parameters} />;
	}

	return null;
};

export const getTemplateVariableInputExtensionHandler: ExtensionHandler<any> = (extension) => {
	if (!extension) {
		return null;
	}
	const { extensionKey, parameters } = extension;

	if (extensionKey === EXTENSION_KEY.TEMPLATE) {
		return <TemplateVariableInput parameters={parameters} />;
	}

	return null;
};
